<template>
    <button
        v-if="!headerIntersecting"
        type="button"
        class="btn btn-primary bg-base-content hover:bg-base-content md:flex md:justify-end fixed bottom-25 right-0 z-100 transition-opacity duration-300"
        :class="isScrolling ? 'opacity-75' : 'opacity-100'"
        @click="scrollToTop"
    >
        <span class="hidden lg:block">
            {{ $t('product.listing.backToTopBtn') }}
        </span>
        <MiscIcon name="chevron-up" />
    </button>
</template>
<script lang="ts" setup>
import { useDebounceFn, useEventListener, useIntersectionObserver } from '@vueuse/core'

const headerIntersecting = ref(true)
const headerElement = ref<HTMLElement | null>(null)

useIntersectionObserver(headerElement, ([entry]) => {
    if (entry) headerIntersecting.value = entry.isIntersecting
})

// Plain scroll listener rather than vueuse's useScroll: that composable also tracks
// x/y/arrived-state/directions, which forces a synchronous getComputedStyle + layout
// read on every single scroll event -- unnecessary cost (and jank risk on a long
// product listing page) for a value we only use as a boolean.
const isScrolling = ref(false)
const stopScrolling = useDebounceFn(() => { isScrolling.value = false }, 200)
useEventListener('scroll', () => {
    isScrolling.value = true
    stopScrolling()
}, { passive: true })

onMounted(() => {
    headerElement.value = document.querySelector('header')
})

function scrollToTop () {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}
</script>
